module.exports = __webpack_public_path__ + "static/media/monitoring-check.7e5c8a3d.svg";